import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent),
  },
  {
    path: 'terms-agreement',
    loadComponent: () =>
      import('./pages/terms/terms.component').then(m => m.TermsAgreementComponent),
  },

  
  { path: '**', redirectTo: '' },
];
